import { View } from 'react-native';
import { Text } from 'app/design/primitives/text';
import { HubButton, styles } from '../components';
import { OfferHubStorageNotice } from './offer-hub-storage-notice';
import { OfferHubLoadingNotice } from './offer-hub-loading-notice';
import { OfferHubStage } from './offer-hub-stage';
import { OfferHubDock } from './offer-hub-dock';
import type { OfferHubState } from '../hooks';

export function OfferHubSuggestionsTab({
  tab,
  showError,
  queue,
  session,
  candidates,
  roundError,
  t,
  startList,
  swiping,
  tutorialVisible,
  swipeTutorialSwiping,
  loaded,
  replayingSwipeTutorial,
  swipeTutorialStep,
  swipeTutorialCard,
  focused,
  setSwipeTutorialStep,
  currentItem,
  completed,
  completedLists,
  accepted,
  navigation,
  statistics,
  refreshStatistics,
  pending,
  items,
  swipeCard,
  decide,
  theme,
  inProgress,
  round,
  overviewActive,
  failed,
  fetchingRound,
  close,
}: OfferHubState) {
  return (
    <View
      style={[styles.flex, tab !== 'suggestions' && { display: 'none' }]}
      accessibilityElementsHidden={tab !== 'suggestions'}
      importantForAccessibility={tab !== 'suggestions' ? 'no-hide-descendants' : 'auto'}
    >
      {showError ? <OfferHubStorageNotice t={t} queue={queue} session={session} /> : null}
      {candidates.isError || roundError ? <OfferHubLoadingNotice t={t} startList={startList} /> : null}
      <OfferHubStage
        swiping={swiping}
        tutorialVisible={tutorialVisible}
        swipeTutorialSwiping={swipeTutorialSwiping}
        loaded={loaded}
        t={t}
        replayingSwipeTutorial={replayingSwipeTutorial}
        swipeTutorialStep={swipeTutorialStep}
        swipeTutorialCard={swipeTutorialCard}
        tab={tab}
        focused={focused}
        setSwipeTutorialStep={setSwipeTutorialStep}
        currentItem={currentItem}
        completed={completed}
        completedLists={completedLists}
        accepted={accepted}
        navigation={navigation}
        statistics={statistics}
        refreshStatistics={refreshStatistics}
        pending={pending}
        items={items}
        swipeCard={swipeCard}
        showError={showError}
        decide={decide}
        theme={theme}
        inProgress={inProgress}
        round={round}
        overviewActive={overviewActive}
      />
      {failed.length ? (
        <View style={styles.notice}>
          <Text variant="bodySmall" color="text.error">
            {t('failedTitle')}
          </Text>
          <HubButton tone="ghost" onPress={() => queue?.retry()}>
            {t('retry')}
          </HubButton>
        </View>
      ) : null}
      <OfferHubDock
        loaded={loaded}
        replayingSwipeTutorial={replayingSwipeTutorial}
        swipeTutorialStep={swipeTutorialStep}
        swipeTutorialCard={swipeTutorialCard}
        t={t}
        fetchingRound={fetchingRound}
        showError={showError}
        setSwipeTutorialStep={setSwipeTutorialStep}
        startList={startList}
        completed={completed}
        close={close}
        swiping={swiping}
        swipeCard={swipeCard}
        currentItem={currentItem}
        inProgress={inProgress}
      />
    </View>
  );
}
